import { axiosInstance, axiosPublicInstance } from '../axios';
import { CreateDiagramI, FetchDiagramI } from '../types/diagram';

export const createNewDiagram = (payload: CreateDiagramI) => {
  return axiosInstance.post('/api/diagrams/create/', payload);
};

export const fetchDiagram = (diagramId?: string) => {
  return axiosInstance.get<FetchDiagramI>(`/api/diagrams/${diagramId}/`);
};

export const fetchPublicViewDiagram = (diagramId?: string) => {
  return axiosPublicInstance.get<FetchDiagramI>(
    `/api/diagrams/public-view/${diagramId}/`,
  );
};

export const updateDiagram = (
  payload: any,
  diagramID: string,
  returnAllDiagrams = '',
) => {
  return axiosInstance.patch<FetchDiagramI[]>(
    `/api/diagrams/${diagramID}/?return_all_diagrams=${returnAllDiagrams}`,
    payload,
  );
};

export const deleteDiagram = (diagramId?: string) => {
  return axiosInstance.delete(`/api/diagrams/${diagramId}/`);
};

export const getCreateTableQuery = (diagramId?: string) => {
  return axiosInstance.get(
    `/api/diagrams/generate-create-table-query/${diagramId}/`,
  );
};

export const getInsertQuery = (diagramId?: string) => {
  return axiosInstance.get(
    `/api/diagrams/generate-insert-into-query/${diagramId}/`,
  );
};
export const submitDiagram = (payload: any) => {
  return axiosInstance.post('api/diagrams/submit/', payload);
};
